/**
 * (c) 智汇考题
 */

let url = "https://education-api.zhihuidati.com";
export default {
  url: url,
};
